import { render, staticRenderFns } from "./PasswordRepeat.vue?vue&type=template&id=c7054ea2"
import script from "./PasswordRepeat.vue?vue&type=script&lang=js"
export * from "./PasswordRepeat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports